import React from 'react';

import { parentsLimitExceededError } from '../constants';

const ParentsLimitExceededDescription: React.FC = () => (
  <>
    {parentsLimitExceededError.descriptionLines.map((line, index) => (
      <React.Fragment key={line}>
        {index > 0 && <br />}
        {line}
      </React.Fragment>
    ))}
  </>
);

export default ParentsLimitExceededDescription;
